import {Injectable} from '@angular/core';
import {Meta, Title} from "@angular/platform-browser";
import {TranslateService} from "@ngx-translate/core";

@Injectable({
	providedIn: 'root'
})
export class SeoService {

	readonly tagNames = [
		'title',
		'author',
		'description',
		'keywords'
	];

	constructor(private titleService: Title, private meta: Meta, private translateService: TranslateService) {
	}

	setTitle(title: string) {
		this.titleService.setTitle(title);
	}

	addMetadataTags() {
		const tags = this.tagNames.map(name => {
			return {
				name: name,
				content: this.translateService.instant(`common.meta.${name}`)
			};
		});
		this.meta.addTags(tags);
	}

	removeMetadataTags() {
		this.tagNames.forEach(name => {
			this.meta.removeTag(`name=${name}`);
		});
	}

	updateTags() {
		this.tagNames.forEach(name => {
			this.meta.updateTag({
				name: name, content: this.translateService.instant(`common.meta.${name}`)
			});
		});
	}
}
